import src from "IMAGE";
export default { src, width: 736, height: 1308, blurWidth: 5, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAIAAAC+k6JsAAAASUlEQVR42kWMUQ6AMAhD+WZsiML9r+obxuwlkLaQyvWz1jIziQgM291VVYhRx2sz57RGUN+RR7SgqiozSbdn7obWMcbu4/I0pC+zoQcDjBQ9uwAAAABJRU5ErkJggg=="};
